/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useEffect, useState } from 'react'
import { UserProviderProps } from '../types/globalTypes'

export interface Stock {
  codeId: number
  material: string
  density: string
  format: string
  finishing: string
  fabrication: string
  heatTreatment: string
  originCountry: string
  supplier: string
  stockStreet: string
  shelf: string
  stockLocation: string
  quantity: string
  totalWeight: string
  dimension1: string
  dimension2: string
  lengthInMm: string
  costPerKg: string
  costPerMm: string
  totalCost: string
  code: string
  invoice: File[]
  ncm: string
  certificates: File[]
  receivedDate: string
  totalCmc: string
  trackingNumber: string
  family: string
  description: string
  stockStatus: string
  characteristic: string
  purchaseOrder: string
  measurementUnit: string
  availableBalance: string
  nf: string
  certificateNumber: string
  heatNumber: string
}

interface StockContextType {
  stock: Stock
  setStock: React.Dispatch<React.SetStateAction<Stock>>
  resetContext: () => void
  stockComponent: string
  setStockComponent: React.Dispatch<React.SetStateAction<string>>
  importFromExcelModal: boolean
  setImportFromExcelModal: React.Dispatch<React.SetStateAction<boolean>>
  tableFile: any
  setTableFile: React.Dispatch<React.SetStateAction<any>>
  stockQuantity: number
  setStockQuantity: React.Dispatch<React.SetStateAction<number>>
  movementQuantity: number
  setMovementQuantity: React.Dispatch<React.SetStateAction<number>>
  details: boolean
  setDetails: React.Dispatch<React.SetStateAction<boolean>>
}

const initialStockState: Stock = {
  codeId: 0,
  material: '',
  density: '',
  format: '',
  finishing: '',
  fabrication: '',
  heatTreatment: '',
  originCountry: '',
  supplier: '',
  stockStreet: '',
  shelf: '',
  stockLocation: '',
  quantity: '',
  totalWeight: '',
  dimension1: '',
  dimension2: '',
  lengthInMm: '',
  costPerKg: '',
  costPerMm: '',
  totalCost: '',
  code: '',
  invoice: [],
  ncm: '',
  certificates: [],
  receivedDate: '',
  totalCmc: '',
  trackingNumber: '',
  family: '',
  description: '',
  stockStatus: '',
  characteristic: '',
  purchaseOrder: '',
  measurementUnit: 'KG',
  availableBalance: '0',
  nf: '',
  certificateNumber: '',
  heatNumber: '',
}

const StockContext = createContext<StockContextType>({
  stock: initialStockState,
  setStock: () => {},
  resetContext: () => {},
  stockComponent: '',
  setStockComponent: () => {},
  importFromExcelModal: false,
  setImportFromExcelModal: () => {},
  tableFile: '',
  setTableFile: () => {},
  stockQuantity: 7,
  setStockQuantity: () => {},
  movementQuantity: 7,
  setMovementQuantity: () => {},
  details: false,
  setDetails: () => {},
})

export default StockContext

export const StockProvider: React.FC<any> = ({ children }) => {
  const [stock, setStock] = useState<Stock>(initialStockState)
  const [stockComponent, setStockComponent] = useState<string>('table')
  const [importFromExcelModal, setImportFromExcelModal] = useState<boolean>(false)
  const [tableFile, setTableFile] = useState<any>()
  const [stockQuantity, setStockQuantity] = useState<number>(8)
  const [movementQuantity, setMovementQuantity] = useState<number>(8)
  const [details, setDetails] = useState<boolean>(false)

  const resetContext = () => {
    setStock(initialStockState)
  }

  return (
    <StockContext.Provider
      value={{
        stock,
        setStock,
        resetContext,
        stockComponent,
        setStockComponent,
        importFromExcelModal,
        setImportFromExcelModal,
        tableFile,
        setTableFile,
        stockQuantity,
        setStockQuantity,
        movementQuantity,
        setMovementQuantity,
        details,
        setDetails,
      }}
    >
      {children}
    </StockContext.Provider>
  )
}
